import React from 'react'

const BaseLayout: React.FC = ({ children }) => {
  return (
    <>
      {children}
    </>
  )
}

export default BaseLayout
